import { Spec } from "@entities/compare/ui/CompareDataGrid/types";

enum CompareSpecsTitles {
    MARK_MODEL_GEN = "Марка, модель, поколение",
    PLATFORM = "Платформа",
    PRICE = "Стоимость",
    BASIC_SPECS = "Основные характеристики"
}

const specsMarkModelGen: Spec[] = [
    { label: "Марка", key: "mark" },
    { label: "Модель", key: "model" },
    { label: "Поколение", key: "generation" }
];

const specsPrice: Spec[] = [{ label: "Стоимость", key: "price", extraKey: "priceUsd" }];

const specsPlatform: Spec[] = [{ label: "Платформа", key: "statusId" }];

const specsBasic: Spec[] = [
    { label: "Год выпуска", key: "year" },
    { label: "Пробег, км", key: "mileage" },
    { label: "Цвет", key: "prepColor" },
    { label: "Руль", key: "prepWheel" },
    { label: "Тип двигателя", key: "prepEngineType" },
    { label: "Мощность в л.с.", key: "horsePower" },
    { label: "Привод", key: "prepDriveType" },
    { label: "Трансмиссия", key: "prepTransmission" },
    { label: "Объем двигателя, л", key: "displacement" },
    { label: "Владельцев по ПТС", key: "ownersCount" }
];

export const sectionsSpecs = [
    { title: CompareSpecsTitles.MARK_MODEL_GEN, specs: specsMarkModelGen },
    { title: CompareSpecsTitles.PLATFORM, specs: specsPlatform },
    { title: CompareSpecsTitles.PRICE, specs: specsPrice },
    { title: CompareSpecsTitles.BASIC_SPECS, specs: specsBasic }
];